import { render, staticRenderFns } from "./SignDocumentsWrapper.vue?vue&type=template&id=1af6b26f&scoped=true&"
import script from "./SignDocumentsWrapper.vue?vue&type=script&lang=js&"
export * from "./SignDocumentsWrapper.vue?vue&type=script&lang=js&"
import style0 from "./SignDocumentsWrapper.vue?vue&type=style&index=0&id=1af6b26f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af6b26f",
  null
  
)

export default component.exports